import { defineRouting } from 'next-intl/routing';
import { TranslationLanguage } from './constants';

export const routing = defineRouting({
    // A list of all locales that are supported
    locales: Object.values(TranslationLanguage),

    // Used when no locale matches
    defaultLocale: TranslationLanguage.EN_GB,
});
